import api from "./capTableApi";
import { SpocDetailModel } from "../types/OnBoardDataModel";

export async function getSpocDetails(): Promise<SpocDetailModel[]> {
  return api.get(`/v1/company/companySpoc/`).then((res) => res.data.data);
}

export async function getSpocTemplate(): Promise<string> {
  return api.get("/v1/company/companySpoc/template").then((res) => res.data.data);
}

export async function addSpocDetails(spoc: SpocDetailModel): Promise<any> {
  return api
    .post("/v1/company/companySpoc/create", spoc)
    .then((res) => res.data);
}

export async function updateSpocDetails(spoc: SpocDetailModel): Promise<any> {
  return api
    .post("/v1/company/companySpoc/update", spoc)
    .then((res) => res.data);
}

export async function bulkUploadSpocDetails(file: File): Promise<any> {
  const formData = new FormData();
  formData.append("file", file);
  return api
    .post("/v1/company/companySpoc/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export async function removeSpocDetails({
  email,
}: {
  email: string;
}): Promise<string> {
  return api
    .delete(`/v1/company/companySpoc/remove`, {
      data: { email },
    })
    .then((res) => res.data.data);
}
